export enum CountrySupportedModules {
  REGISTRATION = 'Registration',
  USER_LOCALE = 'UserLocale',
  COMPANY_LOCALE = 'CompanyLocale',
  ADDRESS = 'Address',
  USER_ACCOUNT_PHONE_NUMBER = 'UserAccountPhoneNumber',
}
export enum SupportedStatus {
  SUPPORTED = 'Supported',
  NOT_SUPPORTED = 'NotSupported',
  LOCKED = 'Locked',
  REMOVED = 'Removed',
  SCHEDULE = 'Schedule',
}

export enum SupportedTypes {
  USER_LOCALE = 'UserLocale',
}

export enum SecurityPolicyEnums {
  MFA = 'mfa',
  PASSWORD_LENGTH = 'passwordLength',
  NUMERICAL_LENGTH = 'numberLength',
  UPPER_CASE_LENGTH = 'upperCaseLength',
  LOWER_CASE_LENGTH = 'lowerCaseLength',
  SPECIAL_CHAR_LENGTH = 'specialCharLength',
  PASSWORD_EXPIRATION_DAYS = 'passwordExpirationDays',
  WEBAPP_SESSION_TIME = 'webAppSessionTime',
  TIMEOUT_OVERLAY = 'timeoutOverlay',
  EFFECTIVE_LENGTH = 'effectiveLength',
  PRELAUNCH_STATUS = 'prelaunchStatus',
  PRELAUNCH_PASSWORD = 'prelaunchPassword',
}
export enum CommunityStatus {
  ENDORSED = 'Endorsed',
  CONTESTED = 'Contested',
  UNENDORSED = 'Unendorsed',
  COMMUNITY_FLAGGED = 'Community Flagged',
}

export enum FollowStatus {
  MUTUAL_FOLLOW = 'Mutual Follow',
  FOLLOWER = 'Follower',
  MUTUAL_FOLLOWER = 'Mutual Follower',
  FOLLOWING = 'Following',
}

export enum FollowedBy {
  VISIT = 'Visit',
  SHARE = 'Share',
}
export enum FollowType {
  SHARE = 'Share',
  VISIT = 'Visit',
  MANUAL = 'Manual',
}

export enum FilterChipCSS {
  SELECTED = 'Selected',
  DEFAULT = 'Default',
}

export enum LandingPagePreferenceTypes {
  PersonalLandingPage = 'PersonalLandingPage',
  CompanyLandingPage = 'CompanyLandingPage',
  CompanyList = 'CompanyList',
  AccelerationList = 'AccelerationLList',
  AccelerationLInstance = 'AccelerationLInstance',
}

export enum RecordShareType {
  ALL = 'All',
  SHARED_IN = 'SharedIn',
  SHARED_OUT = 'SharedOut',
  UPDATES = 'Updates',
}

export enum SharedType {
  DIRECT_SHARE = 'DirectShare',
  INDIRECT_SHARE = 'IndirectShare',
}

export enum EntityType {
  USER = 'User',
  ORG = 'Org',
  PLATFORM = 'Platform',
  ALL = 'All',
}

export enum SortOptions {
  DATE_ADDED = 'createdDate',
  NAME = 'name',
  OBJECT_ID = 'objectID',
  PERSPECTIVE = 'Perspective',
  DELETED_DATE = 'deletedDate',
}

export enum CloudStorageProviderType {
  AWS = 'AWS',
  AZURE = 'Azure',
  GOOGLE = 'Google',
}

export enum Modules {
  NONE = 'none',
  CONTACTS = 'contacts',
  FILES = 'files',
  INTERVIEWS = 'interviews',
  CALENDAR = 'calendar',
  SETTINGS = 'settings',
  MY_ACCOUNT = 'my-account',
  ACCOUNT_ADMIN = 'account-admin',
  CHAT_RECORDS = 'chat-records',
  SCHEDULER = 'scheduler',
  CONFIGURATION = 'configuration',
}

export enum ComparatorOperation {
  ACCEPT = 'accept',
  IGNORE = 'ignore',
  UNDO = 'undo',
}

export enum RecordExistence {
  REALIZED = 'Realized',
  TRASHED = 'Trashed',
  DELETED = 'Deleted',
  PURGED = 'Purged',
}

export enum RecordVisibility {
  VISIBLE = 'Visible',
  GHOSTED = 'Ghosted',
}
